import { Box } from '@mui/material';
import type { AxiosError } from 'axios';
import { errorCodes, genericErrorMessage } from 'common/constants';
import { displayToastMessage } from 'components/ToastMessage';
import { isEmpty, isString } from 'lodash-es';

const displayBackendErrorMessage = (
  error: any,
  autoClose?: false | number,
  defaultErrorMessage: string = genericErrorMessage,
  // eslint-disable-next-line complexity
) => {
  const e = error as AxiosError<{
    [key: string]: any;
  }>;

  // Do not display an error message for this error.
  if (e.code === 'ERR_NETWORK') return '';

  if (e?.response?.data?.code === errorCodes.MISSING_EXPOSURES_OR_FIELD_GROUPS) {
    return displayToastMessage(
      'ERROR',
      <span>
        {defaultErrorMessage}
        <Box component="ul" sx={{ m: '2px', paddingInlineStart: '23px' }}>
          {Object.values(e.response?.data?.field_errors).map((entry, index) => (
            <li key={index as number}>{entry as string}</li>
          ))}
        </Box>
      </span>,
    );
  }

  const errorMessageText = { message: defaultErrorMessage, title: '', autoClose };
  const errorMessagesArr = e?.response?.data?.messages;
  const errorMessage = errorMessagesArr?.[0];

  if (!isEmpty(errorMessagesArr) && isString(errorMessage)) {
    const errorMessageTitle = errorMessage.match(/.*(?=\n\n)/)?.[0];

    errorMessageText.message = errorMessage;

    if (errorMessageTitle) {
      const restOfTheMessage = errorMessage.replace(`${errorMessageTitle}\n\n`, '');

      errorMessageText.title = errorMessageTitle;
      errorMessageText.message = restOfTheMessage;
    }

    // prevents autoClose if message is too big (more than 200 char)
    const BIG_MESSAGE_CHAR_LIMIT = 200;

    if (errorMessageText.message.length + errorMessageText.title.length > BIG_MESSAGE_CHAR_LIMIT) {
      errorMessageText.autoClose = false;
    }
  }

  if (!Array.isArray(errorMessagesArr) && typeof e?.response?.data === 'object') {
    const errorSingleMessage = e?.response?.data?.message;

    return displayToastMessage(
      'ERROR',
      !isEmpty(errorSingleMessage) && isString(errorSingleMessage)
        ? errorSingleMessage
        : defaultErrorMessage,
      autoClose,
    );
  }

  if (e.name === 'Error') {
    return displayToastMessage('ERROR', e?.message, autoClose);
  }

  return displayToastMessage(
    'ERROR',
    errorMessageText.message,
    errorMessageText.autoClose,
    errorMessageText.title,
  );
};

export default displayBackendErrorMessage;
